import { FC } from "react";
import TeamsTable from "@/components/teams/teamsTable";
import RestrictedPage from "@/consumer/restrictedPage";

const TeamsList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_team">
      <TeamsTable />
    </RestrictedPage>
  );
};

export default TeamsList;
